import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { semantic_colors } from '../../foundation';

export const Page = ({ children }: PropsWithChildren) => {
  return <Main>{children}</Main>;
};

const Main = styled.main`
  width: 100%;
  background-color: ${semantic_colors.background.base};
`;
